import { render } from "./SideBar.vue?vue&type=template&id=7c253b08&scoped=true&ts=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=7c253b08&lang=scss&scoped=true"
import "./SideBar.vue?vue&type=style&index=1&id=7c253b08&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c253b08"]])

export default __exports__